import React, { useState, useEffect } from 'react'
import { APIS } from '../../../../../utils/api-factory'
import Loader from '../../../../presentationals/Loader/Loader.component'
export default function Logs({ userDetails,PayloadBorrowerId }) {
    const [activityData, setactivityData] = useState("")
    const [loader,setloader] =useState(false)

    useEffect(() => {
        getData()
    }, [])

    function getData() {

setloader(true)
        fetch(APIS.NEW_ACTIVITY_LOGS_API_BY_USERID + PayloadBorrowerId)
            .then(res => res.json())
            .then(res => {
                setactivityData(res)
            })
            .finally(
                setloader(false)
            )
    }

    function convertMillisecondsToHMS(milliseconds) {
        const totalSeconds = Math.floor(milliseconds / 1000);
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        return {
            hours,
            minutes,
            seconds
        };
    }
    return (
        <>
        {
            loader ? <Loader /> :""
        }
            <div className="activity-logs container-fluid animated fadeIn ">
                <div className='row'>

                    <div className='col-sm-2 col-xs-12'>
                        {activityData !== '' && activityData !== null && activityData !== undefined && activityData?.listByStatus !== undefined ? activityData?.listByStatus?.map((data, i) => {
                            const isLastEntry = i === activityData?.listByStatus?.length - 1;
                            const { hours, minutes, seconds } = convertMillisecondsToHMS(data.time);

                            return (
                                <>
                                    <div className='activity-circle-activetick' style={{ marginTop: i === 0 ? '30px' : '' }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z" /></svg>
                                    </div>
                                    <h6 className='h6stepper' >{data?.status}</h6>
                                    <h6 className='clocktextstepper' style={{ right: i === 0 ? '42%' : '40%' }}><span className='fa fa-clock-o'></span>&nbsp;&nbsp;<>{hours !== 0 ? hours + ':' : ''}</>{minutes}:{seconds} minutes</h6>

                                    {isLastEntry ? (
                                        <>
                                            <div className='stepperlineinActive'></div>
                                            <div className='activity-circle-inactive'></div>
                                        </>
                                    ) : (

                                        <div className='stepperlineActive'></div>
                                    )}
                                </>
                            );
                        }) : ""}


                    </div>
                    <div className='col-sm-10 col-xs-12' >

                        {activityData !== '' && activityData !== null && activityData !== undefined && activityData?.listByStatus !== undefined && activityData?.listByStatus ? activityData?.listByStatus?.map((data, i) => {
                            return (
                                <>
                                    <h4 style={{ marginTop: i === 0 ? '40px' : '' }}><b>{data.status}</b></h4>
                                    <div className="tableactivity" style={{ height: '265px', overflow: 'auto' }}>
                                        <div className="Activites-table table-other" style={{ overflow: 'auto' }}>
                                            <table className="table table-hover align-middle text-center">
                                                <thead>
                                                    <tr className="align-middle">
                                                        <th scope="col" style={{ width: '20%' }} colSpan={1}>Date/Time</th>

                                                        <th scope="col" style={{ width: '60%' }} colSpan={1}>Activity</th>
                                                        <th scope="col" style={{ width: '20' }} colSpan={1}>Performed By</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {data.activity.map((j, i) => {
                                                        // console.l
                                                        return (
                                                            <tr>
                                                                <td style={{ width: '20%', whiteSpace: 'break-spaces' }}>{j.date}</td>

                                                                <td style={{ width: '60%', whiteSpace: 'break-spaces' }}>{j.comment}</td>
                                                                <td style={{ width: '20%', whiteSpace: 'break-spaces' }}>{j.empId}</td>
                                                            </tr>
                                                        )


                                                    })}

                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                </>
                            )
                        }) : ""}
                    </div>
                </div>
            </div>
        </>
    )
}
